module.exports = __webpack_public_path__ + "static/modal4-329ff8f6fbb6ea43c547943353a330c4.png";